export { default as getCorrectName } from './getCorrectName';
export { default as getPrettifiedPhone } from './getPrettifiedPhone';
export { default as getObjectFromArray } from './getObjectFromArray';
export { default as formValidation } from './formValidation';
export { default as orderBy } from './orderBy';
